'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _color = require('color');

var _color2 = _interopRequireDefault(_color);

var _reactackleCore = require('reactackle-core');

var _reactackleIcons = require('reactackle-icons');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** '+1' is needed to be sure that sidebar is placed over header */
var sidebarZIndex = function sidebarZIndex(base) {
  return (0, _reactackleCore.zIndexNav)(base) + 1;
},
    sidebarMinHeight = 40,
    sidebarMinWidth = 50,
    toggleHoverColor = function toggleHoverColor(base) {
  return (0, _color2.default)((0, _reactackleCore.colorPaletteGrey900)(base)).darken(0.15);
};

exports.default = {
  sidebar: {
    minHeight: sidebarMinHeight,
    backgroundColor: _reactackleCore.colorPaletteGrey800,
    fontColor: _reactackleCore.bodyFontColorAlt,
    fontSize: _reactackleCore.fontSizeBody,
    lineHeight: 1.5,
    zIndex: sidebarZIndex,
    widthChangingBreakpoint: _reactackleCore.breakpointLarge,

    state: {
      collapsed: {
        width: sidebarMinWidth
      },

      expanded: {
        width: 250
      }
    }
  },

  region: {
    scrollableMinHeight: 200,

    border: {
      thickness: 1,
      color: _reactackleCore.colorPaletteGrey700
    }
  },

  toggleButton: {
    height: sidebarMinHeight,
    fontSize: _reactackleCore.fontSizeBody,
    fontWeight: _reactackleCore.fontWeightNormal,
    lineHeight: 1.5,
    textTransform: 'none',
    zIndex: sidebarZIndex,
    paddingRight: 0,
    iconElement: _react2.default.createElement(_reactackleIcons.IconArrowChevronLeft, { size: 'custom', color: 'inherit' }),

    style: {
      collapsed: {
        backgroundColor: _reactackleCore.colorPaletteGrey900,
        fontColor: _reactackleCore.bodyFontColorAlt,

        hover: {
          backgroundColor: toggleHoverColor,
          fontColor: _reactackleCore.bodyFontColorAlt
        },

        focus: {
          backgroundColor: toggleHoverColor,
          fontColor: _reactackleCore.bodyFontColorAlt
        }
      },

      expanded: {
        backgroundColor: _reactackleCore.colorPaletteGrey900,
        fontColor: _reactackleCore.bodyFontColorAlt,

        hover: {
          backgroundColor: toggleHoverColor,
          fontColor: _reactackleCore.bodyFontColorAlt
        },

        focus: {
          backgroundColor: toggleHoverColor,
          fontColor: _reactackleCore.bodyFontColorAlt
        }
      }
    },

    icon: {
      height: 40,
      width: null,
      imgSize: null,

      style: {
        collapsed: {
          width: sidebarMinWidth,
          marginLeft: 0,
          color: 'inherit',
          opacity: 0.9,

          hover: {
            color: 'inherit',
            opacity: 1
          },

          focus: {
            color: 'inherit',
            opacity: 1
          }
        },

        expanded: {
          width: 40,
          marginLeft: (0, _reactackleCore.bmodule)(1.5),
          color: 'inherit',
          opacity: 0.9,

          hover: {
            color: 'inherit',
            opacity: 1
          },

          focus: {
            color: 'inherit',
            opacity: 1
          }
        }
      }
    },

    content: {
      paddingY: (0, _reactackleCore.bmodule)(1),
      paddingX: (0, _reactackleCore.bmodule)(1.5)
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-sidebar/dist/styles/theme.js
// module id = 810
// module chunks = 0